import styled from "styled-components";

import { mixins } from "@similarweb/styles";
import { Checkbox, Combobox } from "@similarweb/ui-components";

export const StyledLeadScoreCheckbox = styled(Checkbox)`
    label {
        ${mixins.setFontVariant("body1")};
    }
`;

export const StyledLeadScoreFilterOptionRow = styled.div<{ $isDisabled?: boolean }>`
    opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};
    cursor: ${({ $isDisabled }) => ($isDisabled ? "not-allowed" : "pointer")};
`;

export const StyledAddRuleOption = styled(Combobox.Option)`
    justify-content: center;
`;

export const StyledAddRuleOptionLabel = styled.span`
    display: block;
    width: 100%;
    text-align: center;
    white-space: nowrap;
`;
